import { z } from 'zod';

import { useEntityByIdSuspenseQuery } from '@eluve/apollo-client';
import { FCC } from '@eluve/components';
import { NotFoundError } from '@eluve/eluve-errors';
import { useAppointmentContext } from '@eluve/frontend-appointment-hooks';
import { graphql } from '@eluve/graphql.tada';

const getAppointmentDetailsQuery = graphql(`
  query getAppointmentDetails($tenantId: uuid!, $appointmentId: uuid!) {
    appointmentsByPk(tenantId: $tenantId, id: $appointmentId) {
      __typename
      id
    }
  }
`);

const guidSchema = z.string().uuid();
const isGuid = (id: string) => guidSchema.safeParse(id).success;

export const AppointmentGuard: FCC = ({ children }) => {
  const { tenantId, appointmentId } = useAppointmentContext();

  if (!isGuid(tenantId) || !isGuid(appointmentId)) {
    throw new NotFoundError('Appointment not found');
  }

  useEntityByIdSuspenseQuery(
    getAppointmentDetailsQuery,
    { tenantId, appointmentId },
    { entityKey: 'appointmentsByPk', entityType: 'Appointment' },
  );

  return children;
};
